import {immerable} from 'immer';
import Entity from '../entity/Entity';
import Address from '../address/Address';


/**
 * Person entity type definition
 *
 * @typedef {Object} Person
 * @property {?Address} address
 * @property {?string} type
 * @property {?string} name
 */

/**
 * Person entity-to-DTO mapping
 *
 * @type {Object<string, EntityDTOProperty>}
 */
const personEntityDTOMapping = {
    type: {
        dtoProperty: 'type',
        defaultValue: '',
    },
    name: {
        dtoProperty: 'name',
        defaultValue: '',
    },
    address: {
        dtoProperty: 'address',
        defaultValue: new Address(),
        entity: Address,
    },
};

/**
 * Person entity
 *
 * @class
 * @extends Entity
 * @type {Person}
 */
export default class Person extends Entity {
    [immerable] = true;

    static entityDTOMapping = personEntityDTOMapping;

    /**
     * @constructor
     * @param rawObject
     */
    constructor(rawObject = {}) {
        super();
        this.initialize(rawObject);
    }
}
